import { jsx } from "react/jsx-runtime";
import { ExpandableInput, GlowEffectWrapper } from "@pcln/horizon";
import { useEffect, useState } from "react";
function PennyChatInput({ showGlowEffect = false, voiceButtonType = 'textButton', placeholder = 'Ask Penny a question', value, onChange, disabled, maxRows = 7, dictationDisabled, showDictationButton, voiceButtonDisabled, onVoiceClickHandler, onSubmitClickHandler, onDictationClickHandler, voiceButtonTooltipProps }) {
    const [activeInput, setActiveInput] = useState(true);
    useEffect(()=>{
        if (showGlowEffect) setActiveInput(true);
        else {
            const timer = setTimeout(()=>setActiveInput(false), 600);
            return ()=>{
                clearTimeout(timer);
            };
        }
    }, [
        showGlowEffect
    ]);
    return /*#__PURE__*/ jsx(GlowEffectWrapper, {
        active: showGlowEffect,
        mode: "rotate",
        colors: [
            '--color-pennyAccents-4',
            '--color-pennyAccents-12',
            '--color-pennyAccents-11',
            '--color-pennyAccents-4'
        ],
        blur: "soft",
        duration: 1,
        slots: {
            wrapperSlot: 'p-0',
            glowSlot: 'rounded-full'
        },
        children: /*#__PURE__*/ jsx(ExpandableInput, {
            voiceButtonType: voiceButtonType,
            slots: {
                wrapperSlot: `${activeInput ? 'bg-penny-1' : ''}`
            },
            placeholder: placeholder,
            id: "penny-chat-input",
            onChange: onChange,
            value: value,
            maxRows: maxRows,
            disabled: disabled,
            dictationDisabled: dictationDisabled,
            showDictationButton: showDictationButton,
            voiceButtonDisabled: voiceButtonDisabled,
            onVoiceClickHandler: onVoiceClickHandler,
            onSubmitClickHandler: onSubmitClickHandler,
            onDictationClickHandler: onDictationClickHandler,
            colorVariant: "glass",
            voiceButtonTooltipProps: voiceButtonTooltipProps
        })
    });
}
export { PennyChatInput };
